import { useMutation } from "@tanstack/react-query";
import { paymentApi, TossPaymentsConfirmType } from "api/paymentApi";
import { userAtom } from "../recoil/userAtom";
import { useSetRecoilState } from "recoil";
import { captureException } from "../utils/sentry";

export function useConfirmTossPayments() {
  const setUser = useSetRecoilState(userAtom);

  return useMutation(
    // 토스 결제 성공 API
    async (payload: TossPaymentsConfirmType) => {
      const response = await paymentApi.confirmTossPayments(payload);
      // 비즈니스 실패(미확정 + 실패 메시지)인 경우 에러로 처리하여 onSuccess 흐름을 막는다.
      if (
        response?.result?.isConfirmed !== true &&
        response?.result?.failureMessage
      ) {
        throw new Error(response.result.failureMessage as string);
      }
      return response;
    },
    {
      onSuccess: async (responseData, variables) => {
        // (1) 결제확인 API 성공 후, userApi.getDetail()로 최신 유저 정보 가져오기
        // try {
        //   const data = await userApi.getDetail();
        //   if (data?.result) {
        //     setUser((prev) => ({
        //       ...prev,
        //       ...data.result,
        //     }));
        //   }
        // } catch (error) {
        //   console.error("userApi.getDetail() 호출 실패:", error);
        // }
      },
      onError: (error: unknown) => {
        captureException(error, {
          tags: { action: "toss_payments_confirm" },
        });
      },
    }
  );
}
